export const getengagementDestination = (href = '', { isListingDetail = false } = {}) =>
  (href || '').includes('#reviews')
    ? isListingDetail
      ? 'jump-to_product_reviews'
      : 'go-to_product_details'
    : 'go-to_product_reviews'
